import { Component, Emit, Prop, PropSync, Vue } from 'vue-property-decorator'
import { ConfigurationSynopticTemplateResponse } from '@/modules/configurationModule/detail/templates/synoptic-templates/services/configuration-synoptic-template/configuration-synoptic-template.dto'

@Component
export default class ConfigurationTemplatesSynopticTemplatesModalBasicForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @PropSync('synopticTemplate') syncedSynopticTemplate!: Partial<ConfigurationSynopticTemplateResponse>

    @Emit()
    create() {}

    @Emit()
    update() {}

    get updateMode(): boolean {
        return !!this.syncedSynopticTemplate?.id
    }

    get modelValidated(): boolean {
        const hasErrors = this.$validator.errors.any()
        const isDirty = this.$_someFieldIsDirty(this.fields)
        const checkTitle = !!this.syncedSynopticTemplate.title?.length
        return !hasErrors && isDirty && checkTitle
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        const validStructure = this.syncedSynopticTemplate.tree?.every(treeNode => !!treeNode.code.length && !!treeNode.text.length)
        if (!validStructure) {
            this.$_showErrorModal(this.$tc('configuration.sections.synopticTemplate.structureValidationError'))
        } else if (valid) {
            if (this.updateMode) {
                this.update() // emits an event
            } else {
                this.create() // emits an event
            }
        }
    }
}
